import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { ForexTransactionsService } from 'app/forex-transactions/forex-transactions.service';
import { OTPRequestData } from 'app/model/tillotp';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'mifosx-forex-transactions',
    templateUrl: './forex-transactions.component.html',
    styleUrls: ['./forex-transactions.component.scss']
})
export class ForexTransactionsComponent implements OnInit {

    transactionType: string;
    forexTransactionsForm: FormGroup;
    rate: number;

    selectedTeller: any;
    tellerSub: Subscription;

      /** Handle transaction approval */
    approvalDialogRef: Observable<any>;
    approvalData = {};

    constructor(private route: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private forexTransactionsService: ForexTransactionsService,   
        private tellerGlobalService: TellerGlobalServiceService,           
        private receiptService: ReceiptServiceService,
        private matDialog: MatDialog,
        private dialogHelper: DialogHelper) {

        this.transactionType = this.route.snapshot.params['action'] == 'sell' ? 'V' : 'C';
    }

    ngOnInit(): void {

        this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
        this.forexTransactionsForm = this.formBuilder.group({
            'clientId': ['', Validators.required],
            'amount': ['', Validators.required],
            'rate': ['', Validators.required]
        });

        this.forexTransactionsService.getLatestExchangeRate().subscribe(res => {
            this.rate = this.transactionType == 'V' ? res.sellRate : res.buyRate;
            this.forexTransactionsForm.controls['rate'].setValue(this.rate);
        });
    }

    ngOnDestroy(){
        if(this.tellerSub){
            this.tellerSub.unsubscribe();
        }
    }

    submit() {
        const data = {
            "amountInQuetzals": this.forexTransactionsForm.value.amount,
            "amountInDollars": this.forexTransactionsForm.value.amount,
            "rate": this.rate,
            "transactionType": this.transactionType,
            "channel": "caja",
            "ctaOrigin": "",
            "ctaDestination": "",
            "tellerId": this.selectedTeller['id'],
            "reference": "CAJA+" + this.transactionType + "+" + this.forexTransactionsForm.value.txAmount,
            "clientId": this.forexTransactionsForm.value.clientId,
            ...this.approvalData
        };
        
        this.approvalData = {};
        this.forexTransactionsService.executeForexTransaction(data).subscribe(res => {

            if(res.hasOwnProperty('httpStatusCode') && res.httpStatusCode === '202' && res.userMessageGlobalisationCode == 'response.msg.approval.required')
            { 
      
              const amount = this.forexTransactionsForm.get('amount').value;
              const currencyCode =  this.transactionType == 'V' ? 'QTZ' : 'USD';
              const otpRequestData: OTPRequestData = {
                requestAmount:  amount,
                entityId: this.selectedTeller['id'],
                title: `Approve ${this.transactionType} of ${amount} ${currencyCode}`
              }
              
              this.approvalDialogRef = this.dialogHelper.showApprovalDialog(otpRequestData,this.matDialog).afterClosed();
              this.approvalDialogRef.subscribe(result => {
      
                if(result && result.hasOwnProperty('approvalToken')){
                    this.approvalData = result;
                    this.submit();
                }
      
              });
            }else {
                this.receiptService.getTellerReport(this.selectedTeller['id'],'Caja_forex',res['id']).subscribe(data => 
                    this.dialogHelper.showDialog(data,this.matDialog,this.router,this.route));
            }
        });
    }

}
